import React from 'react'

const IconHandHeart = ({
  className,
  strokeWidth = '1'
}: {
  className: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M21.0625 19.3125H23.096C23.8162 19.3125 24.5252 19.4903 25.1602 19.83C25.7952 20.1698 26.3364 20.6611 26.736 21.2602L27.1875 21.9375L13.9155 27.1C13.1469 27.3993 12.3185 27.5133 11.4976 27.4327C10.6767 27.3522 9.88628 27.0793 9.1905 26.6363L1.8125 21.9375V14.0625H3.5625C5.86463 14.0625 8.49575 14.9086 9.6875 16.6875H14.0625C15.2228 16.6875 16.3356 17.1484 17.1561 17.9689C17.9766 18.7894 18.4375 19.9022 18.4375 21.0625H8.8125"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22.7076 3.69946C22.4109 3.38867 22.0557 3.1394 21.6626 2.9659C21.2694 2.79241 20.8459 2.69809 20.4163 2.68834C19.9867 2.67859 19.5594 2.7536 19.1587 2.90907C18.7581 3.06455 18.3921 3.29745 18.0815 3.59446C17.882 3.78436 17.7076 3.99903 17.5626 4.23321C17.2991 3.80907 16.9421 3.45085 16.5188 3.18598C16.0955 2.92111 15.6172 2.75662 15.1205 2.70511C14.6238 2.65359 14.122 2.71641 13.6533 2.88877C13.1847 3.06112 12.7617 3.33843 12.4168 3.69946C11.7882 4.35802 11.4375 5.23341 11.4375 6.14378C11.4375 7.05415 11.7882 7.92953 12.4168 8.58809L17.5626 13.9142L22.7085 8.58809C23.3371 7.92952 23.6878 7.05404 23.6877 6.1436C23.6875 5.23317 23.3365 4.35781 22.7076 3.69946Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default IconHandHeart
